import { render, staticRenderFns } from "./CreditsGratitude.vue?vue&type=template&id=08eb1884&scoped=true"
import script from "./CreditsGratitude.vue?vue&type=script&lang=js"
export * from "./CreditsGratitude.vue?vue&type=script&lang=js"
import style0 from "./CreditsGratitude.vue?vue&type=style&index=0&id=08eb1884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eb1884",
  null
  
)

export default component.exports